module.exports = __webpack_public_path__ + "img/thumb-up.683715cc.png";